import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData } from 'src/utils/axios/serverHelper';
import { formatDate } from 'src/utils/string/stringUtil';

import { SYS5010_R01Dto, SYS5010_R01Filter } from './Dto_SYS5010_R01';

const baseUrl = `${config.apiUrl}/SYS5010_R01`;

const getParams = (filter: Partial<SYS5010_R01Filter>) => ({
	startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
	endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
	searchUserId: filter.userId || undefined,
});

export const getSYS5010_R01List = async (
	option: string,
	params: Partial<SYS5010_R01Filter>,
) => {
	return await getData<ResponseDto<SYS5010_R01Dto[]>>(`${baseUrl}/${option}`, {
		params: getParams(params),
	});
};

export const getSYS5010_R01AllCount = async (params: Partial<SYS5010_R01Filter>) => {
	return await getData<ResponseDto<number>>(`${baseUrl}/allCount`, {
		params: getParams(params),
	});
};

export const downloadExcel_SYS5010_R01 = async (
	option: string,
	params: Partial<SYS5010_R01Filter>,
) => {
	return await getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, {
		params: getParams(params),
	});
};
